import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

interface UnauthorizedProps {
  requiredRole?: string;
}

export default function Unauthorized({ requiredRole }: UnauthorizedProps) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center space-y-4 max-w-md">
        <ShieldAlert className="w-16 h-16 text-error mx-auto" />
        <h1 className="text-2xl font-bold text-textPrimary">Access Denied</h1>
        <p className="text-textSecondary">
          You don't have permission to access this page.
          {requiredRole && (
            <> Required role: <span className="text-warning font-mono">{requiredRole}</span></>
          )}
        </p>
        <Link
          to="/"
          className="inline-block px-4 py-2 bg-primary text-textOnPrimary rounded-lg hover:bg-primary-hover transition-colors text-sm"
        >
          Back to Chat
        </Link>
      </div>
    </div>
  );
}
